module.exports = __webpack_public_path__ + "img/cs-protrain-2.398e25f2.jpg";